module.exports = __webpack_public_path__ + "static/media/section-deals.995675b4.svg";